/**
 * 
 * key
 * 
 */


const key = 'Y2hlY2tfbGlzdF9xdWVzdGlvbg=='

export default key 